export function useAction(state, props) {
    var action = props.action, actionEnable = props.actionEnable;
    var isLoading = state.isLoading, isReadonly = state.isReadonly, isDisabled = state.isDisabled;
    function show() {
        return Boolean(action &&
            !isLoading());
    }
    function enable() {
        return Boolean(actionEnable !== false &&
            !isReadonly() &&
            !isDisabled());
    }
    return {
        show: show(),
        enable: enable(),
    };
}
